import FingerPrint from "./FingerPrint";

export default FingerPrint;